import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { TbFileExport } from "react-icons/tb";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import { TbCubePlus } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { MdDeleteOutline } from "react-icons/md";

import "../Inventory/Inventory.css";
import "../Dashboard/Dashboard.css";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

export const StateInvoice = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [filterToggler, setFilterToggler] = useState("");

  const [activeMenu, setactiveMenu] = useState("distributor");

  function handleSelectMenu(menu) {
    setactiveMenu(menu);
  }
  // Filters
  const [searchText, setSearchText] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [status, setStatus] = useState("");
  const [sortBy, setSortBy] = useState("");

  // function convertDateToDDMMYYYY(dateString) {
  //   if (!dateString) return "";

  //   const [year, month, day] = dateString.split("-");
  //   return `${day}-${month}-${year}`;
  // }

  const [purchaseData, setPurchaseData] = useState({});

  async function fetchPurchaseDetails() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/invoice/distributor/purchased-invoice/",
      );
      if (response.data.status === "Success" || response.status === 200) {
        setPurchaseData(response.data.data);
        console.log("Purchase details fetched successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch purchase details",
      );
      console.log("failed to fetch purchase details");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPurchaseDetails();
  }, []);

  // pos
  const [pospage, setPosPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_invoice_pos_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [posrowsPerPage, setPosRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_invoice_pos_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [postotalCount, setPosTotalCount] = useState(0);

  const handleChangePosRowsPerPage = (event) => {
    setPosRowsPerPage(+event.target.value);
    setPosPage(0); // reset to first page
    sessionStorage.setItem("dis_invoice_pos_rowsPerPage", +event.target.value);
    sessionStorage.setItem("dis_invoice_pos_page", 0);
  };
  const [posInvoiceData, setPosInvoiceData] = useState({});
  async function fetchPosInvoiceDetails() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: pospage + 1, // atleast 1 page
          page_size: posrowsPerPage,
          search: searchText,
          payment_mode: paymentMode,
          status: status,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };

      const response = await axiosInstance.get(
        "/invoice/distributor/pos-sales-invoice/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setPosInvoiceData(response.data.data);
        setPosTotalCount(response.data?.data.count);
        console.log("Pos details fetched successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch pos details");
      console.log("Failed to fetch pos details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchPosInvoiceDetails();
  }, [pospage, posrowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (pospage !== 0) {
        setPosPage(0);
      } else {
        fetchPosInvoiceDetails();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentMode, status, selectedLabel, sortBy]);

  const [salespage, setSalesPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_invoice_sales_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [salesrowsPerPage, setSalesRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_invoice_sales_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [salestotalCount, setSalesTotalCount] = useState(0);

  const handleChangeSalesRowsPerPage = (event) => {
    setSalesRowsPerPage(+event.target.value);
    setSalesPage(0); // reset to first page
    sessionStorage.setItem(
      "dis_invoice_sales_rowsPerPage",
      +event.target.value,
    );
    sessionStorage.setItem("dis_invoice_sales_page", 0);
  };

  const [salesInvoiceData, setSalesInvoiceData] = useState({});

  async function fetchSalesInvoiceDetails() {
    try {
      setLoading(true);

      const config = {
        params: {
          page: salespage + 1,
          page_size: salesrowsPerPage,
          search: searchText,
          payment_mode: paymentMode,
          status: status,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };

      const response = await axiosInstance.get(
        "/invoice/distributor/sales-invoice/",
        config,
      );

      if (response.data.status === "Success" || response.status === 200) {
        setSalesInvoiceData(response.data?.data);
        setSalesTotalCount(response.data?.data?.count);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to fetch sales invoice details",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchSalesInvoiceDetails();
  }, [salespage, salesrowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (salespage !== 0) {
        setSalesPage(0);
      } else {
        fetchSalesInvoiceDetails();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentMode, status, selectedLabel, sortBy]);

  // online order invoices
  const [onlinepage, setOnlinePage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_invoice_online_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [onlinerowsPerPage, setOnlineRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_invoice_online_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [onlinetotalCount, setOnlineTotalCount] = useState(0);

  const handleChangeOnlineRowsPerPage = (event) => {
    setOnlineRowsPerPage(+event.target.value);
    setOnlinePage(0); // reset to first page
    sessionStorage.setItem(
      "dis_invoice_online_rowsPerPage",
      +event.target.value,
    );
    sessionStorage.setItem("dis_invoice_online_page", 0);
  };

  const [onlineInvoiceData, setOnlineInvoiceData] = useState({});

  async function fetchOnlineInvoiceDetails() {
    try {
      setLoading(true);

      const config = {
        params: {
          page: onlinepage + 1,
          page_size: onlinerowsPerPage,
          search: searchText,
          payment_mode: paymentMode,
          status: status,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };

      const response = await axiosInstance.get(
        "/invoice/distributor/online-invoice/",
        config,
      );

      if (response.data.status === "Success" || response.status === 200) {
        setOnlineInvoiceData(response.data?.data);
        setOnlineTotalCount(response.data?.data?.count);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to fetch online invoice details",
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchOnlineInvoiceDetails();
  }, [onlinepage, onlinerowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (onlinepage !== 0) {
        setOnlinePage(0);
      } else {
        fetchOnlineInvoiceDetails();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentMode, status, selectedLabel, sortBy]);

  // CLEAR FILTERS
  function handleClearFilters() {
    setSearchText("");
    setFilterToggler("");
    setPaymentMode("");
    setStatus("");
    setSelectedLabel("");
    setSortBy("");
  }

  // RESET Search
  function handleReset() {
    setSearchText("");
  }

  async function EditInvoiceStatus(id, status) {
    try {
      const payload = {
        status: status,
      };
      const response = await axiosInstance.put(
        `/invoice/update-invoice-status/${id}/`,
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data?.message || "Invoice status updated");
        fetchPurchaseDetails();
        fetchPosInvoiceDetails();
        fetchSalesInvoiceDetails();
        fetchOnlineInvoiceDetails();
      }
    } catch (error) {
      toast.error(error.response.data?.message || "Failed to update invoice");
      console.log("Failed to update invoice");
    }
  }
  async function handleExport() {
    try {
      setLoading(true);

      let url = "";
      let defaultFileName = "export.xlsx";

      if (activeMenu === "distributor") {
        url = "/invoice/distributor/purchased-invoice-excel/";
        defaultFileName = "purchase_invoice.xlsx";
      } else if (activeMenu === "pos") {
        url = "/invoice/distributor/pos-sales-invoice-excel/";
        defaultFileName = "pos_invoice.xlsx";
      } else if (activeMenu === "salesInvoice") {
        url = "/invoice/distributor/sales-invoice-excel/";
        defaultFileName = "sales_invoice.xlsx";
      } else {
        return;
      }

      const response = await axiosInstance.get(url, {
        responseType: "blob",
      });

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = defaultFileName;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      let errorMessage = "Failed to export";

      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMessage = json.message || errorMessage;
        } catch (e) {
          // fallback if parsing fails
        }
      } else {
        errorMessage = error.response?.data?.message || errorMessage;
      }

      toast.error(errorMessage);
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  }

  const cardsData = {
    distributor: purchaseData?.invoice_card,
    pos: posInvoiceData?.invoice_card,
    salesInvoice: salesInvoiceData?.invoice_card,
    onlineOrderInvoice: onlineInvoiceData?.invoice_card,
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="inventoryContainer">
        <div className="container">
          <div className="inventoryTitle">Invoices</div>
          <div className="inventorySubtitle">
            Track your order invoices and payment status.
          </div>

          {/* cards section  */}
          <div className="inventoryCardsGrid">
            <div className="inventoryCard">
              <div>Total Invoices</div>
              <div>{cardsData?.[activeMenu]?.total_invoice ?? "---"}</div>
            </div>
            <div className="inventoryCard">
              <div>Paid Invoices</div>
              <div>{cardsData?.[activeMenu]?.paid_invoice ?? "---"}</div>
            </div>
            <div className="inventoryCard">
              <div>Unpaid (Pending)</div>
              <div>{cardsData?.[activeMenu]?.unpaid ?? "---"}</div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Invoice No., Customer Name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Filter by</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("");
                        setPaymentMode("");
                        setStatus("");
                      }}
                    >
                      All
                    </Dropdown.Item>
                    {/* Payment Type with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Payment Mode ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("UPI");
                            setPaymentMode("UPI");
                            setStatus("");
                          }}
                        >
                          UPI
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Cash");
                            setPaymentMode("Cash");
                            setStatus("");
                          }}
                        >
                          Cash
                        </Dropdown.Item>
                      </div>
                    </div>

                    {/* status with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Status ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Paid");
                            setStatus("Paid");
                            setPaymentMode("");
                          }}
                        >
                          Paid
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Unpaid");
                            setStatus("Unpaid");
                            setPaymentMode("");
                          }}
                        >
                          Unpaid
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(filterToggler ||
            selectedLabel ||
            searchText ||
            paymentMode ||
            status ||
            sortBy) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of{" "}
                </span>{" "}
                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchText}
                  </>
                )}
                {paymentMode && (
                  <>
                    {" "}
                    , <strong>Payment Mode:</strong> {paymentMode}
                  </>
                )}
                {status && (
                  <>
                    {" "}
                    , <strong>Status:</strong> {status}
                  </>
                )}
                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}
                  </>
                )}
                {sortBy && (
                  <>
                    {" "}
                    , <strong>Sort By:</strong> {sortBy}
                  </>
                )}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          {/* table menu  */}
          <div className="inventoryFilterContainer">
            <div className="inventoryMenu">
              <div
                onClick={() => handleSelectMenu("distributor")}
                className={`menuTitle ${
                  activeMenu === "distributor" ? "active" : ""
                }`}
              >
                Purchase Invoices
              </div>
              <div
                onClick={() => handleSelectMenu("pos")}
                className={`menuTitle ${activeMenu === "pos" ? "active" : ""}`}
              >
                POS
              </div>
              <div
                onClick={() => handleSelectMenu("salesInvoice")}
                className={`menuTitle ${
                  activeMenu === "salesInvoice" ? "active" : ""
                }`}
              >
                Sales Invoices
              </div>
              <div
                onClick={() => handleSelectMenu("onlineOrderInvoice")}
                className={`menuTitle ${
                  activeMenu === "onlineOrderInvoice" ? "active" : ""
                }`}
              >
                Online Order Invoices
              </div>
            </div>
            <div className="inventoryFilters">
              <div className="inventoryBtnExport">
                <button onClick={handleExport}>
                  Export{" "}
                  <span>
                    <TbFileExport />
                  </span>
                </button>
              </div>
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    Sort by
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setSortBy("total")}>
                      Total
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("date")}>
                      Date
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("invoice")}>
                      Invoice
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          {activeMenu === "distributor" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Invoice</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Order</TableCell>
                      <TableCell align="left">Total (₹)</TableCell>
                      <TableCell align="left">Payment type</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {purchaseData?.results?.length > 0 ? (
                      purchaseData?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell component="th" scope="row">
                            {row.invoice_number}
                          </TableCell>
                          <TableCell align="left">{row.due_date}</TableCell>
                          <TableCell align="left">{row.order}</TableCell>
                          <TableCell align="left">{row.total}</TableCell>

                          <TableCell align="left">{row.payment_type}</TableCell>

                          <TableCell
                            align="left"
                            style={{
                              color: (() => {
                                switch (row.status) {
                                  case "Unpaid":
                                    return "#F59E0B";
                                  case "Paid":
                                    return "#10B981";
                                  default:
                                    return "var(--color-font-secondary)";
                                }
                              })(),
                            }}
                          >
                            {row.status}
                          </TableCell>

                          <TableCell align="left">
                            {row.status === "Unpaid" ? (
                              <button
                                className="btnTableManage"
                                onClick={() =>
                                  navigate("/state-invoice-manageDistributor")
                                }
                              >
                                Manage
                              </button>
                            ) : (
                              <button
                                className="btnTableView"
                                onClick={() =>
                                  navigate("/state-invoice-viewDistributor")
                                }
                              >
                                View
                              </button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
          {activeMenu === "pos" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Invoice</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Customer Name</TableCell>
                      <TableCell align="left">Total (₹)</TableCell>
                      <TableCell align="left">Payment Mode</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {posInvoiceData?.results?.length > 0 ? (
                      posInvoiceData?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell component="th" scope="row">
                            {row.invoice_number ?? "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.due_date ?? "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.customer_name ?? "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.total ?? "---"}
                          </TableCell>

                          <TableCell align="left">
                            {row.payment_mode ?? "---"}
                          </TableCell>

                          <TableCell
                            align="left"
                            // style={{
                            //   color: (() => {
                            //     switch (row.status) {
                            //       case "Unpaid":
                            //         return "#F59E0B";
                            //       case "Paid":
                            //         return "#10B981";
                            //       default:
                            //         return "var(--color-font-secondary)";
                            //     }
                            //   })(),
                            // }}
                          >
                            <select
                              value={row.status}
                              className="invoiceTableSelect"
                              onChange={(e) => {
                                EditInvoiceStatus(row.id, e.target.value);
                              }}
                            >
                              <option value="Paid">Paid</option>
                              <option value="Unpaid">Unpaid</option>
                            </select>
                          </TableCell>

                          <TableCell align="left">
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-view", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              View
                            </button>
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-edit", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btnTableView"
                              onClick={() => {
                                navigate("/state-invoice-share", {
                                  state: { Id: row.public_id },
                                });
                              }}
                            >
                              Share
                            </button>
                            {/* {row.status === "Unpaid" ? (
                        <button className="btnTableManage" onClick={()=>navigate("/state-orders-manage")}>Manage</button>
                      ) : (
                        <button className="btnTableView" onClick={()=>navigate("/state-viewOrders")}>View</button>
                      )} */}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={postotalCount}
                page={pospage}
                onPageChange={(event, newPage) => {
                  setPosPage(newPage);
                  sessionStorage.setItem("dis_invoice_pos_page", newPage);
                }}
                rowsPerPage={posrowsPerPage}
                onRowsPerPageChange={handleChangePosRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}
          {activeMenu === "salesInvoice" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Invoice</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Customer Name</TableCell>
                      <TableCell align="left">Total (₹)</TableCell>
                      <TableCell align="left">Payment Mode</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {salesInvoiceData?.results?.length > 0 ? (
                      salesInvoiceData?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell component="th" scope="row">
                            {row.invoice_number || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.due_date || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.customer_name || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.total || "---"}
                          </TableCell>

                          <TableCell align="left">
                            {row.payment_mode || "---"}
                          </TableCell>

                          <TableCell
                            align="left"
                            // style={{
                            //   color: (() => {
                            //     switch (row.status) {
                            //       case "Unpaid":
                            //         return "#F59E0B";
                            //       case "Paid":
                            //         return "#10B981";
                            //       default:
                            //         return "var(--color-font-secondary)";
                            //     }
                            //   })(),
                            // }}
                          >
                            <select
                              value={row.status}
                              className="invoiceTableSelect"
                              onChange={(e) => {
                                EditInvoiceStatus(row.id, e.target.value);
                              }}
                            >
                              <option value="Paid">Paid</option>
                              <option value="Unpaid">Unpaid</option>
                            </select>
                          </TableCell>

                          <TableCell align="left">
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-view", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              View
                            </button>
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-edit", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btnTableView"
                              onClick={() => {
                                navigate("/state-invoice-share", {
                                 state: { Id: row.public_id },
                                });
                              }}
                            >
                              Share
                            </button>
                            {/* {row.status === "Unpaid" ? (
                        <button className="btnTableManage" onClick={()=>navigate("/state-orders-manage")}>Manage</button>
                      ) : (
                        <button className="btnTableView" onClick={()=>navigate("/state-viewOrders")}>View</button>
                      )} */}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={salestotalCount}
                page={salespage}
                onPageChange={(event, newPage) => {
                  setSalesPage(newPage);
                  sessionStorage.setItem("dis_invoice_sales_page", newPage);
                }}
                rowsPerPage={salesrowsPerPage}
                onRowsPerPageChange={handleChangeSalesRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}

          {activeMenu === "onlineOrderInvoice" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Invoice</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Agent Name</TableCell>
                      <TableCell align="left">Total (₹)</TableCell>
                      <TableCell align="left">Payment Mode</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {onlineInvoiceData?.results?.length > 0 ? (
                      onlineInvoiceData?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell component="th" scope="row">
                            {row.invoice_number || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.due_date || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.customer_name || "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.total || "---"}
                          </TableCell>

                          <TableCell align="left">
                            {row.payment_mode || "---"}
                          </TableCell>

                          <TableCell
                            align="left"
                            // style={{
                            //   color: (() => {
                            //     switch (row.status) {
                            //       case "Unpaid":
                            //         return "#F59E0B";
                            //       case "Paid":
                            //         return "#10B981";
                            //       default:
                            //         return "var(--color-font-secondary)";
                            //     }
                            //   })(),
                            // }}
                          >
                            <select
                              value={row.status}
                              className="invoiceTableSelect"
                              onChange={(e) => {
                                EditInvoiceStatus(row.id, e.target.value);
                              }}
                            >
                              <option value="Paid">Paid</option>
                              <option value="Unpaid">Unpaid</option>
                            </select>
                          </TableCell>

                          <TableCell align="left">
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-view", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              View
                            </button>
                            <button
                              className="btnTableView me-2"
                              onClick={() => {
                                navigate("/state-invoice-edit", {
                                  state: { Id: row.id },
                                });
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btnTableView"
                              onClick={() => {
                                navigate("/state-invoice-share", {
                                  state: { Id: row.public_id },
                                });
                              }}
                            >
                              Share
                            </button>
                            {/* {row.status === "Unpaid" ? (
                        <button className="btnTableManage" onClick={()=>navigate("/state-orders-manage")}>Manage</button>
                      ) : (
                        <button className="btnTableView" onClick={()=>navigate("/state-viewOrders")}>View</button>
                      )} */}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={onlinetotalCount}
                page={onlinepage}
                onPageChange={(event, newPage) => {
                  setOnlinePage(newPage);
                  sessionStorage.setItem("dis_invoice_online_page", newPage);
                }}
                rowsPerPage={onlinerowsPerPage}
                onRowsPerPageChange={handleChangeOnlineRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
